/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { BtnIconAdd6 } from "../../icons/BtnIconAdd6";
import { BtnDiamondIcon } from "../BtnDiamondIcon";
import "./style.css";

export const OrientationWrapper = ({
  label = "Text",
  orientation,
  className,
  btnDiamondIconIcon = <BtnIconAdd6 className="btn-icon-add-2" color="white" />,
  btnDiamondIconRectangleClassName,
  textClassName,
}) => {
  return (
    <div
      className={`orientation-wrapper orientation-0-${orientation} ${className}`}
    >
      <BtnDiamondIcon
        className="instance-node"
        icon={btnDiamondIconIcon}
        rectangleClassName={btnDiamondIconRectangleClassName}
      />
      <div className={`text-3 ${textClassName}`}>{label}</div>
    </div>
  );
};

OrientationWrapper.propTypes = {
  label: PropTypes.string,
  orientation: PropTypes.oneOf(["vertical", "horizontal"]),
};
